import { FiChevronRight } from "react-icons/fi";
import React, { useState } from "react";
import { 
  MdHub,
  MdWaterfallChart,
  MdStorage,
  MdGridView
} from "react-icons/md";


export function renderGeneralServices() {
  return <GeneralServicesComponent />;
}

function GeneralServicesComponent() {
  const [zoomVideo, setZoomVideo] = useState(null);

  return (
  <div className="transition-opacity duration-300">
    {/* Breadcrumb */}
    <nav className="flex flex-wrap items-center gap-2 text-sm text-[#9a734c] mb-1">
      <a className="hover:text-primary hover:underline" href="#">Netraa APM</a>
      <FiChevronRight className="text-[14px]" />
      <span>Product Capabilities</span>
      <FiChevronRight className="text-[14px]" />
      <span className="text-[#1b140d] dark:text-white font-medium">APM - General Services </span>
    </nav>
    {/* Page Heading */}
    <div className="mb-1 mt-8 border-b border-[#e5e7eb] dark:border-[#3a2e25] pb-8">
      <h1 className="text-4xl md:text-5xl font-bold text-[#1b140d] dark:text-white tracking-tight mb-4">
        APM – <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">General Services</span>
      </h1>
      <p className="text-lg text-gray-600 dark:text-gray-300 leading-relaxed">
        Comprehensive monitoring for your service mesh. Visualize topology, correlate distributed traces with logs, and deep dive into instance and endpoint performance metrics to identify bottlenecks instantly.
      </p>
    </div>

    {/* Section 1: Service Overview & Topology */}
    <section className="mb-1 mt-6 scroll-mt-24" id="service-overview">
      <h2 className="text-2xl font-bold text-[#1b140d] dark:text-white mb-4 flex items-center gap-2">
        <span className="bg-primary/10 text-primary p-1.5 rounded-lg material-symbols-outlined"><MdHub/></span>
        Service Overview & Topology
      </h2>
      <p className="text-gray-600 dark:text-gray-300 mb-6 leading-relaxed">
        The Service Overview dashboard provides a high-level view of your application's architecture. Netraa automatically maps the relationships between your services, identifying upstream and downstream dependencies in real-time. The Dynamic Topology Map highlights service health through color-coded nodes based on latency, error rates, and throughput.
      </p>

      {/* Topology Map Visual */}
      <div className="bg-white dark:bg-[#2c2219]relative overflow-hidden group">
        <div className="absolute top-4 right-4 z-10 bg-white/80 dark:bg-black/50 backdrop-blur px-3 py-1 rounded-full text-xs font-bold border border-gray-200 dark:border-gray-700 flex items-center">
          <span className="size-2 rounded-full bg-green-500 animate-pulse"></span> Live Topology
        </div>

        {/* Mockup Container */}
<div className="flex items-center justify-center">
<video
  className="w-25 h-45 object-cover object-top cursor-zoom-in"
  autoPlay
  loop
  muted
  playsInline
  onClick={() => setZoomVideo("/videos/topology1.mp4")}
>
  <source src="/videos/topology1.mp4" type="video/mp4" />
</video>

</div>


      </div>
    </section>

    {/* Section 2: Distributed Traces & Logs */}
<section className="mb-1 mt-6 scroll-mt-24" id="distributed-traces">
  <h2 className="text-2xl font-bold text-[#1b140d] dark:text-white mb-4 flex items-center gap-2">
    <span className="bg-primary/10 text-primary p-1.5 rounded-lg material-symbols-outlined"><MdWaterfallChart/></span>
    Distributed Traces &amp; Logs Correlation
  </h2>
  <p className="text-gray-600 dark:text-gray-300 mb-6 leading-relaxed">
    Drill down into individual requests with distributed tracing. Our 'Trace Waterfall' visualizes the entire request lifecycle across microservices. Click on any span to instantly see correlated logs in the side panel, eliminating the need to switch contexts between your tracing and logging tools.
  </p>

  {/* Visual: Trace Waterfall */}
  <div className="">
    
    {/* Waterfall Chart */}
 <div className="flex items-center justify-center">
<video
  className="w-25 h-45 object-cover object-top cursor-zoom-in"
  autoPlay
  loop
  muted
  playsInline
  onClick={() => setZoomVideo("/videos/traces.mp4")}
>
  <source src="/videos/traces.mp4" type="video/mp4" />
</video>

</div>

  </div>
</section>

    {/* Section 3: Database Visibility */}
<section className="scroll-mt-24 mt-6" id="database-visibility">
  <h2 className="text-xl font-bold text-[#1b140d] dark:text-white mb-3 flex items-center gap-2">
    <span className="bg-primary/10 text-primary p-1.5 rounded-lg material-symbols-outlined"><MdStorage /></span>
    Database Call Visibility
  </h2>
  <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
    Slow queries are often the bottleneck in service performance. Netraa identifies N+1 queries and slow-running SQL statements. The APM agent automatically parses SQL to group similar queries, providing aggregated metrics on execution time and row counts.
  </p>
  {/* <div className="mt-4 p-4 bg-blue-50 dark:bg-blue-900/10 border border-blue-100 dark:border-blue-900/30 rounded-lg">
    <h4 className="text-sm font-bold text-blue-800 dark:text-blue-300 mb-1">Pro Tip</h4>
    <p className="text-xs text-blue-700 dark:text-blue-400">
      Use the "Explain Plan" feature in the trace view to see the database execution strategy for any slow query detected over 500ms.
    </p>
  </div> */}
</section>

{/* Section 4: Instance Level Monitoring */}
<section className="scroll-mt-24 mt-6" id="instance-level">
  <h2 className="text-xl font-bold text-[#1b140d] dark:text-white mb-3 flex items-center gap-2">
    <span className="bg-primary/10 text-primary p-1.5 rounded-lg material-symbols-outlined"><MdGridView/></span>
    Instance Level Monitoring
  </h2>
  <p className="text-sm text-gray-600 dark:text-gray-300 mb-4 leading-relaxed">
    Monitor the health of every individual instance in your cluster. Quickly spot outliers consuming excessive CPU or memory.
  </p>

  {/* Instance Health Grid */}
 <div className="flex items-center justify-center">
<video
  className="w-25 h-45 object-cover object-top cursor-zoom-in"
  autoPlay
  loop
  muted
  playsInline
  onClick={() => setZoomVideo("/videos/instance.mp4")}
>
  <source src="/videos/instance.mp4" type="video/mp4" />
</video>

</div>
</section>

{/* Section 5: Endpoint Level Monitoring */}
<section className="mb-20 mt-6 scroll-mt-24" id="endpoint-level">
  <h2 className="text-2xl font-bold text-[#1b140d] dark:text-white mb-4 flex items-center gap-2">
    <span className="bg-primary/10 text-primary p-1.5 rounded-lg material-symbols-outlined"><MdGridView/></span>
    Endpoint Level Monitoring
  </h2>
  <p className="text-gray-600 dark:text-gray-300 mb-6 leading-relaxed">
    Identify the specific API endpoints causing latency for your users. The Top 5 Slow Endpoints widget aggregates response times (P95 and P99) to help you prioritize optimization efforts.
  </p>

  {/* Top 5 Slow Endpoints List */}

<video
  className="w-25 h-45 object-cover object-top cursor-zoom-in"
  autoPlay
  loop
  muted
  playsInline
  onClick={() => setZoomVideo("/videos/end.mp4")}
>
  <source src="/videos/end.mp4" type="video/mp4" />
</video>
</section>
{zoomVideo && (
  <div
    className="fixed inset-0 bg-black/80 flex items-center justify-center z-50"
    onClick={() => setZoomVideo(null)}
  >
    <video
      className="max-w-[90vw] max-h-[90vh] rounded-lg shadow-2xl"
      autoPlay
      loop
      muted
      playsInline
      controls
    >
      <source src={zoomVideo} type="video/mp4" />
    </video>
  </div>
)}


  </div>
);
}